import styled from 'styled-components';
import * as mixins from 'view/styles/mixins';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

interface DropzoneContainerProps {
    hasError?: boolean;
}
const dropzoneErrorBorder = `solid ${token('color.border.danger', colors.R500)}`;
const dropZoneDashedBorder = `dashed ${token('color.border.input', colors.N20)}`;
// eslint-disable-next-line rulesdir/no-styled-export
export const DropzoneContainer = styled.div`
    ${mixins.borderRadius}
    border: 2px ${(props: DropzoneContainerProps) => (props.hasError ? dropzoneErrorBorder : dropZoneDashedBorder)};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const DropzoneContent = styled.div`
    padding: ${token('space.200', '16px')};
    text-align: center;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const DropzoneContentText = styled.div`
    margin-bottom: ${token('space.100', '8px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const AttachedFilesContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    margin-top: ${token('space.200', '16px')};
    text-align: left;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const AttachedFile = styled.div`
    margin: 0 ${token('space.100', '8px')} ${token('space.100', '8px')} 0;
`;
